import React from "react";
import imageUrl from "utils/imageUrl";

function PropertyFeatures() {
  return (
    <div className="terms">
      <h5>Features:</h5>
      <div className="terms__wrapper">
        <div className="terms__single">
          <img src={imageUrl("icons/bed.png")} alt="Bed Rooms" />
          <p>Bedrooms</p>
          <h5 className="neutral-bottom">3</h5>
        </div>
        <div className="terms__single">
          <img src={imageUrl("icons/bath.png")} alt="Bathrooms" />
          <p>Bathrooms</p>
          <h5 className="neutral-bottom">2</h5>
        </div>
        <div className="terms__single">
          <img src={imageUrl("icons/dimension.png")} alt="Annual" />
          <p>Dimensions</p>
          <h5 className="neutral-bottom">600 sqft</h5>
        </div>
        <div className="terms__single">
          <img src={imageUrl("icons/parking.png")} alt="Annual" />
          <p>Car Parking</p>
          <h5 className="neutral-bottom">80 sqft</h5>
        </div>
      </div>
    </div>
  );
}

export default PropertyFeatures;
